import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/atencao-basica`

    const headers = { responseType: "arraybuffer" }

    return {
        termoRecusaCadastro(id)
        {
            return repository.get(`${baseUrl}/termo-recusa-cadastro/${id}`, headers)
        },
        ficha(id)
        {
            return repository.get(`${baseUrl}/ficha/${id}`, headers)
        },
        fichaCadastroDomiciliar(id)
        {
            return repository.get(`${baseUrl}/ficha-cadastro-domiciliar/${id}`, headers)
        },
        fichaResidentes(id)
        {
            return repository.get(`${baseUrl}/ficha-residente/${id}`, headers)
        },
        relatorioAtendimentoOdontologico(queryParms) {
            return repository.get(`${baseUrl}/relatorio-atendimento-odontologico?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAtividadeColetiva(params) {
            return repository.post(`${baseUrl}/relatorio-atividade-coletiva`, params, headers)
        },
        fichaAtividadeColetiva(id)
        {
            return repository.get(`${baseUrl}/ficha-atividade-coletiva/${id}`, headers)
        },
        relatorioCadastroConsistente(params)
        {
            return repository.get(`${baseUrl}/relatorio-cadastro-consistente?${urlUtil.serialize(params)}`, headers)
        },
        relatorioEstatisticoAtendimento(params)
        {
            return repository.get(`${baseUrl}/relatorio-estatistico-atendimento?${urlUtil.serialize(params)}`, headers)
        },
        relatorioInconsistencia(params)
        {
            return repository.get(`${baseUrl}/relatorio-inconsistencia?${urlUtil.serialize(params)}`, headers)
        },
        fichaVisitaDomiciliar(id)
        {
            return repository.get(`${baseUrl}/ficha-visita-domiciliar/${id}`, headers)
        },
        relatorioEstatisticoPacienteCadastrado(params)
        {
            return repository.post(`${baseUrl}/relatorio-estatistico-paciente-cadastrado`, params, headers)
        },
        relatorioVisitaDomiciliar(params) {
            return repository.post(`${baseUrl}/relatorio-visita-domiciliar`, params, headers)
        },
        relatorioAcessoCuidadoProgramado(params)
        {
            return repository.get(`${baseUrl}/relatorio-acesso-cuidado-programado?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoPessoaComDiabete(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-pessoa-com-diabete?${urlUtil.serialize(params)}`, headers)
        },
        relatorioAtendimentoDomiciliar(params)
        {
            return repository.get(`${baseUrl}/relatorio-atendimento-domiciliar?${urlUtil.serialize(params)}`, headers)
        },
        relatorioIndicadorSad(params)
        {
            return repository.get(`${baseUrl}/relatorio-indicador-sad?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoPessoaHipertensao(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-pessoa-hipertensao?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoGestacaoPuerperio(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-gestacao-puerperio?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoDesenvolvimentoInfantil(params)
        {
            return repository.post(`${baseUrl}/relatorio-cuidado-desenvolvimento-infantil`, params, headers)
        },
        relatorioCuidadoMulherPrevencaoCancer(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-mulher-prevencao-cancer?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoPessoaIdosa(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-pessoa-idosa?${urlUtil.serialize(params)}`, headers)
        },
        relatorioAvaliacaoElegibilidadeAdmissao(queryParams) {
            return repository.get(`${baseUrl}/relatorio-avaliacao-elegibilidade-admissao?${urlUtil.serialize(queryParams)}`, headers)
        },
    }
}
